import React from "react";
import "./EditVersion.css";
import VersionForm from "../VersionForm/VersionForm";

const EditVersion = (props) => {
  return <VersionForm></VersionForm>;
};

export default EditVersion;
